import { format } from 'date-fns'

export const getDealerBrandStatus = (date, dealer_brand) => {
  const referenceDate = typeof date === 'string' ? date : format(date, 'yyyy-MM-dd')

  const {
    affiliation_date,
    relationship_end_date,
    contract_expires_date,
    contract_rejected_date,
    appointments_concluded_date,
    appointments_rejected_date,
    appointments_creation_date,
  } = dealer_brand

  const dateMap = {
    appointments_creation_date,
    appointments_concluded_date,
    appointments_rejected_date,
    contract_expires_date,
    contract_rejected_date,
    affiliation_date,
    relationship_end_date,
  }

  const pastDates = Object.entries(dateMap)
    .filter(([_, d]) => d !== '' && d <= referenceDate)
    .sort(([, d1], [, d2]) => d1.localeCompare(d2))

  if (pastDates.length === 0) return 'not_engaged'

  const [lastType] = pastDates[pastDates.length - 1]
  if (lastType === 'affiliation_date') return 'engaged'
  if (
    ['relationship_end_date', 'appointments_rejected_date', 'contract_expires_date', 'contract_rejected_date'].includes(
      lastType
    )
  )
    return 'not_engaged'
  return 'in_progress'
}
